import Route from 'cio/routes/base';
import { inject as service } from '@ember/service';
import AuthService from 'cio/services/auth';
import Transition from '@ember/routing/-private/transition';
import TwoFactorAuthEmailLinkController from './controller';
import { getTwoFactorAuthLinkCookie } from 'cio/utils/auth-cookies';

export default class TwoFactorAuthEmailLinkRoute extends Route {
  @service auth!: AuthService;

  setupController(controller: TwoFactorAuthEmailLinkController, model: unknown, transition: Transition): void {
    super.setupController(controller, model, transition);
    let { token } = this.paramsFor(this.fullRouteName) as { token: string };
    if (token != null) {
      controller.validateTwoFactorAuthLinkToken.perform(token);
    }
  }

  redirect() {
    if (getTwoFactorAuthLinkCookie() == null) {
      return this.router.transitionTo('login');
    }

    return;
  }
}
